import React, { Component } from 'react';
import { Breadcrumb, BreadcrumbItem, Container, FormInline, Row } from "mdbreact";
import { Link } from "react-router-dom";
import { API_URL } from "../../config/Config";
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios/index";
import Merchant from "../../components/merchants/Merchant";
import { connect } from "react-redux";
import axiosRetry from 'axios-retry';
import SectionLoader from "../../components/loader/SectionLoader";
axiosRetry(axios, { retries: 3 });

class MerchantListByCat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            merchants: [],
            catName: '',
            selectedCatId: 0,
            loading: true,
        };
    }

    async componentDidMount() {
        const { params } = await this.props.match;
        const selectedCatId = await params.id;
        const categories = this.props.categories.items;
        const catName = await categories[selectedCatId].name;
        await this.setState({ catName, selectedCatId });
        await this.handleRequest();
    }
    async handleRequest() {
        const { selectedCatId, sortBy } = this.state;
        const data = { "catId": selectedCatId, 'sortby': sortBy };
        // const data = {"catId":13};
        this.setState({ loading: false });
        try {
            const options = {
                method: 'POST',
                headers: { 'content-type': 'application/x-www-form-urlencoded' },
                data: data,
                url: `${API_URL}business-by-cat`,
            };
            // let response = await axios.post(`${API_URL}business-by-cat`, data);
            let response = await axios(options);

            if (response.status < 200 || response.status > 300) {
                const error = new Error(response.statusText);
                error.response = response;
                console.log(error);
                toast.error('خطایی در هنگام دریافت اطلاعات از سرور رخ داد.', {
                    autoClose: 3000,
                    position: toast.POSITION.TOP_RIGHT,
                    rtl: true
                });
            } else {
                let merchants = response.data.data;
                this.setState({
                    merchants
                });
            }
        } catch (e) {
            let apiError = await e.response;
            if (apiError === undefined) {
                console.log(e);
            } else {
                let statusText = await apiError.statusText;
                console.log(statusText);

            }
        }
        this.setState({ loading: true });
    };
    async handelChange(event) {
        await this.setState({
            sortBy: event.target.value
        });
        await this.handleRequest();

    }
    render() {
        const { catName } = this.state;

        return (
            <div className="pt-3">
                <Container>
                    <Breadcrumb className='w-100 white mt-3 rtl'>
                        <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                        {/*<BreadcrumbItem><Link to="/merchantList">کسب و کارها</Link></BreadcrumbItem>*/}
                        <BreadcrumbItem active>{catName}</BreadcrumbItem>
                    </Breadcrumb>

                    <div className="clear-fx white rtl mt-3 mb-3 p-3">
                        <FormInline>
                            <label>مرتب سازی بر اساس:</label>
                            <select className="browser-default border border-success ml-2" onChange={this.handelChange.bind(this)} value={this.state.sortBy}>
                                <option value="1" >جدیدترین کسب و کارها</option>
                                <option value="2">قدیمی ترین کسب و کارها</option>
                                <option value="3">محبوبترین کسب و کارها</option>
                            </select>
                        </FormInline>
                    </div>

                    <div className="p-3 rtl">
                        {!this.state.loading ? <SectionLoader type="spinningBubbles" color="#4fbfa8" /> :
                            <Row>
                                {this.state.merchants.map(merchant =>
                                    <Merchant key={merchant.id} merchantObj={merchant} />
                                )}
                            </Row>
                        }
                    </div>
                    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={5000}
                    />
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        categories: state.categories,
    }
};
export default connect(mapStateToProps, null)(MerchantListByCat);


// WEBPACK FOOTER //
// ./src/containers/merchants/MerchantListByCat.js